export default function toggleBrowserFullScreen() {
  const elem = document.documentElement;
  let isInBrowserFullScreen = false;
  if (elem.requestFullscreen) {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      elem.requestFullscreen();
      isInBrowserFullScreen = true;
    }
  }
  return isInBrowserFullScreen;
}

export function checkIsBrowserFullScreenEnabled() {
  if (document.fullscreenElement) {
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/utils/fullscreen.js